import { Box, FloatingIndicator, UnstyledButton, rem } from '@mantine/core';
import { FC, useEffect, useRef, useState } from 'react';

import navClasses from '../result-nav.module.css';

export interface ResultsSegmentedToggleOption {
  value: string;
  label: string;
}

export interface ResultsSegmentedToggleProps {
  value: string;
  onChange: (value: string) => void;
  options: ResultsSegmentedToggleOption[];
}

export const ResultsSegmentedToggle: FC<ResultsSegmentedToggleProps> = ({
  value,
  onChange,
  options,
}) => {
  const [rootRef, setRootRef] = useState<HTMLDivElement | null>(null);
  const [indicatorReady, setIndicatorReady] = useState(false);
  const controlRefs = useRef<Record<string, HTMLButtonElement | null>>({});

  const setControlRef = (key: string) => (node: HTMLButtonElement | null) => {
    controlRefs.current[key] = node;
  };

  useEffect(() => {
    setIndicatorReady(true);
  }, []);

  return (
    <Box className={navClasses.root} h={rem(36)} ref={setRootRef}>
      {options.map((option) => (
        <UnstyledButton
          key={option.value}
          aria-pressed={value === option.value}
          className={navClasses.control}
          data-status={value === option.value ? 'active' : undefined}
          onClick={() => onChange(option.value)}
          ref={setControlRef(option.value)}
          type="button"
        >
          <span className={navClasses.controlLabel}>{option.label}</span>
        </UnstyledButton>
      ))}
      {indicatorReady && (
        <FloatingIndicator
          className={navClasses.indicator}
          parent={rootRef}
          target={controlRefs.current[value]}
        />
      )}
    </Box>
  );
};

export default ResultsSegmentedToggle;
